'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('hellosign/components/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.typed.changeFonts.linkText'
});

function ChangeFontButton(props) {
    var changeLinkClasses = {
        'm-sign-modal--tabs--type--output--change-link': true,
        'm-button': true,
        'bg-white': true,
        'border-1-light-grey': true,
        'hbg-white': true,
        'hc-light-grey': true,
        'c-light-grey': true
    };
    var spinner = _jsx('img', {
        src: require('./loading-spinner-16.gif'),
        className: 'm-sign-modal--tabs--type--output--spinner'
    });

    var changeLink = _jsx('a', {
        className: (0, _classnames2['default'])(changeLinkClasses),
        onClick: props.handleClick
    }, void 0, _ref);
    return _jsx('div', {
        className: 'm-sign-modal--tabs--type--output'
    }, void 0, changeLink, props.showSpinner ? spinner : null);
}

var TypeInTab = _react2['default'].createClass({
    displayName: 'TypeInTab',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'onBeforeInsert': _react2['default'].PropTypes.func.isRequired,
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'onError': _react2['default'].PropTypes.func.isRequired,
        'isSelected': _react2['default'].PropTypes.bool.isRequired,
        'deviceOrientation': _react2['default'].PropTypes.string.isRequired,
        'screenSize': _react2['default'].PropTypes.string.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'canInsertEverywhere': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true
        };
    },

    getInitialState: function getInitialState() {
        var user = this.props.app.user;
        var fullName = user.getFullName();
        var value = (this.props.type === _constants2['default'].TYPE_INITIALS ? user.getInitials() : fullName) || '';
        return {
            'hasValue': !!fullName,
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'selectedFontIndex': 2,
            'showSpinner': false,
            'textValue': value
        };
    },

    componentDidMount: function componentDidMount() {

        this.adjustInputWidth();

        // Load the initial font family
        var n = this.state.selectedFontIndex % _constants2['default'].CURSIVE_FONTS.length;
        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];
        this.loadFontFamily(chosenFamily);
    },

    componentDidUpdate: function componentDidUpdate() {
        this.adjustInputWidth();
    },

    //  ----  BEHAVIOR  -----------------------------------

    loadFontFamily: function loadFontFamily(fontFamily, okCallback) {

        var onActive = function onActive() {
            if (okCallback) {
                okCallback();
            }
        };

        var onInactive = function onInactive(stop) {

            if (stop === true) {
                console.error('Could not load font ' + fontFamily + ' at all');
                return;
            }

            console.warn('Could not get font ' + fontFamily + ' from Google, loading from our servers instead');

            // Load from CDN
            var cdnFontUrl = _hfReactHelper2['default'].urlHelper('/fonts/' + fontFamily.toLowerCase().replace(/\s/g, '-') + '.css', 'hellosign');
            WebFont.load({
                'custom': {
                    'families': [fontFamily],
                    'urls': [cdnFontUrl]
                },
                'active': onActive,
                'fontinactive': onInactive.bind(this, true)
            });
        };

        // Load font from google
        if (window.WebFont) {
            console.log('Loading font family: ' + fontFamily);
            WebFont.load({
                'google': {
                    'families': [fontFamily]
                },
                'active': onActive,
                'fontinactive': onInactive
            });
        } else if (okCallback) {
            okCallback();
        }
    },

    selectNextFontFamily: function selectNextFontFamily(callback) {

        var self = this;
        var n = (this.state.selectedFontIndex + 1) % _constants2['default'].CURSIVE_FONTS.length;
        var chosenFamily = _constants2['default'].CURSIVE_FONTS[n];

        this.setState({
            'showSpinner': true
        });

        var loadFont = function loadFont() {
            self.loadFontFamily(chosenFamily, function () {
                self.setState({
                    'showSpinner': false,
                    'selectedFontIndex': n // Will trigger the new css font-family to change
                });
            });
        };

        if (this.props.isMobile && this.props.app.signatureRequest) {
            // Make sure we have connectivity before loading fonts on mobile
            // NOTE: We need to trigger a save beforehand because loading font does not
            // go through the API service and will not bring up the connectivity screen
            // when network is down.
            this.props.app.signatureRequest.save(function () {
                loadFont();
            });
        } else {
            // Load font
            loadFont();
        }
    },

    handleInput: function handleInput(evt) {
        var v = evt.target.value;
        this.setState({
            'textValue': v,
            'hasValue': v.replace(/\s/g, '').length > 0
        });
    },

    insertSignature: function insertSignature(insertEverywhere) {
        var _this = this;

        var self = this;
        var el = this.refs.typedSignatureInput;
        var text = _hfReactHelper2['default'].trim(el.value);

        if (!text) {
            this.props.onError({
                'message': this.props.intl.formatMessage({ id: 'signModal.typed.error.' + this.props.type })
            });
        } else {

            var signatureData = {
                'type_code': this.props.type,
                'create_type_code': _constants2['default'].SIGNATURE_TYPE_TYPED,
                'signature': {
                    'text': text,
                    'font_family': _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex]
                }
            };

            if (!this.props.onBeforeInsert || this.props.onBeforeInsert(signatureData) !== false) {

                // Notifies creation has started
                this.props.onInsert(null, null, true);

                // Creates the signature and inserts it
                this.createSignature(signatureData).then(function (signature) {
                    self.props.onInsert(signature, insertEverywhere);
                })['catch'](function (error) {
                    var err = JSON.parse(error.response.text);
                    var msg = err.name ? _this.props.intl.formatMessage({ id: 'signModal.typed.error.' + err.name }) : _this.props.intl.formatMessage({ id: 'error.general.message' });
                    self.props.onError({ 'message': msg });
                });
            }
        }
    },

    createSignature: function createSignature(signatureData) {
        return this.props.app.user.getSignatures(this.props.type).add(signatureData);
    },

    //  ----  HELPERS  ------------------------------------

    adjustInputWidth: function adjustInputWidth() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        var w = '385px';
        if (this.props.app.isMobile) {
            w = this.props.deviceOrientation === _constants2['default'].ORIENTATION_LANDSCAPE ? $('.m-sign-modal--tabs--type', root).width() - 140 + 'px' : '100%'; // 140 = size of the btn
        }
        $('#typedSignatureInput', root).css('width', w);
    },

    isChinese: function isChinese() {
        var intl = this.props.app.intl;
        var locale = intl ? intl.locales[0] : null;
        return locale === 'zh-CN';
    },

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var changeLink;
        var fontFamily = _constants2['default'].CURSIVE_FONTS[this.state.selectedFontIndex];
        var inputStyle = {
            'fontFamily': fontFamily
        };
        var inputClasses = {
            'm-sign-modal--tabs--type--input': true
        };
        var classes = {
            'm-sign-modal--tabs--type': true,
            'has-value': this.state.hasValue
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_TYPE] = true;
        inputClasses['font-' + fontFamily.replace(/\s/g, '-')] = true;

        var changeFontButton = _react2['default'].createElement(ChangeFontButton, _extends({}, this.props, {
            handleClick: this.selectNextFontFamily,
            showSpinner: this.state.showSpinner }));

        return _jsx('div', {
            className: (0, _classnames2['default'])(containerClasses)
        }, void 0, _jsx('span', {
            className: 'm-sign-modal--tabs--tab-title'
        }, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.typed.title',
            values: { type: this.props.type }
        })), _jsx('div', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--content'
        }, void 0, _react2['default'].createElement('input', {
            id: 'typedSignatureInput',
            ref: 'typedSignatureInput',
            type: 'text',
            className: (0, _classnames2['default'])(inputClasses),
            style: inputStyle,
            value: this.state.textValue,
            onChange: this.handleInput,
            onKeyUp: this.handleInput,
            placeholder: this.props.intl.formatMessage({ id: 'signModal.typed.placeholder.' + this.props.type })
        }), !this.isChinese() ? changeFontButton : null)), _react2['default'].createElement(_actionBar2['default'], _extends({}, this.props, {
            type: this.props.type,
            isMobile: this.props.isMobile,
            locales: this.props.locales,
            messages: this.props.messages,
            onInsert: this.insertSignature,
            onClose: this.props.onClose,
            buttonText: this.props.buttonText,
            canInsertEverywhere: this.props.canInsertEverywhere,
            disableButtons: !this.state.hasValue
        })));
    }
});

module.exports = TypeInTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/type-in-tab.jsx
 ** module id = 694
 ** module chunks = 0
 **/